import { useEffect } from 'react';
import CourseStore from '../store';

/**
 * Loads page data whenever the pageId changes.
 * This is used to load the page data when the user changes the page manually.
 * @param pageIdParam pageId
 * @param courseStore course store
 * @param callback optional callback function to be called after page change
 */
export default function usePageChange(
  pageIdParam: string,
  courseStore: CourseStore,
  callback?: () => void,
) {
  useEffect(() => {
    // this triggers only when user changes the page manually, saving the progress in the process
    if (courseStore.loadedInitialData) {
      courseStore.changePageContent(pageIdParam);
      callback?.();
    }
  }, [pageIdParam]);
}
